import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Yui from 'yyui-vue'
import './assets/index.scss'
import 'yyui-vue/dist/yui.css'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-light.css'
Vue.config.productionTip = false

Vue.use(Yui)
Vue.directive('highlight', function (el) {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
}) // 样式文件

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
